<ion-datetime
    #datetimeCalendar
    class="datetime-calendar"
    [ngClass]="{ 'block-center': center }"
    presentation="date"
    [multiple]="enableStartEndDateSelection"
    [preferWheel]="false"
    [min]="minDate"
    [max]="maxDate"
    [dayValues]="dayValues || undefined"
    [multiple]="multiple"
    [value]="value"
    [highlightedDates]="highlightedDates"
    (ionChange)="dateChange($event)"
    [disabled]="disabled"
    id="{{ id }}" />
